import { useSelector } from "react-redux"

import { CREATE_DEBTS_ACCOUNT_NUMBER_NO_MIN } from "../../../../config/featureFlagKeys"
import { selectFeatureFlag } from "../../../../features/featureFlags/selectors"
import { MANUAL_DEBT_RULES, MANUAL_DEBT_RULES_NO_ACCOUNT_NUMBER_MIN } from "./helper"

// The rule set for both Create Debts forms. The flag is per brand, so it drops the
// 8-character account number minimum only for the brands it is on for.
export const useManualDebtRules = () => {
  const noAccountNumberMin = useSelector(selectFeatureFlag(CREATE_DEBTS_ACCOUNT_NUMBER_NO_MIN))
  return noAccountNumberMin ? MANUAL_DEBT_RULES_NO_ACCOUNT_NUMBER_MIN : MANUAL_DEBT_RULES
}
